import { createVariants } from '../lib'

export const taskColors = createVariants({
  variants: {
    text: {
      plant: 'text-task-plant',
      sidedress: 'text-task-sidedress',
      spray: 'text-task-spray',
      striptill: 'text-task-striptill',
      harvest: 'text-task-harvest'
    },
    background: {
      plant: 'bg-task-plant',
      sidedress: 'bg-task-sidedress',
      spray: 'bg-task-spray',
      striptill: 'bg-task-striptill',
      harvest: 'bg-task-harvest'
    },
    border: {
      plant: 'border-task-plant',
      sidedress: 'border-task-sidedress',
      spray: 'border-task-spray',
      striptill: 'border-task-striptill',
      harvest: 'border-task-harvest'
    },
    ring: {
      plant: 'ring-2 ring-inset ring-task-plant',
      sidedress: 'ring-2 ring-inset ring-task-sidedress',
      spray: 'ring-2 ring-inset ring-task-spray',
      striptill: 'ring-2 ring-inset ring-task-striptill',
      harvest: 'ring-2 ring-inset ring-task-harvest'
    },
    chipBackground: {
      plant: 'bg-clover-100',
      sidedress: 'bg-purple-100',
      spray: 'bg-azure-100',
      striptill: 'bg-pink-100',
      harvest: 'bg-marigold-100'
    }
  }
})
